// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

type RequireContext = __WebpackModuleApi.RequireContext;

interface ComponentDictionary {
    [key: string]: React.ComponentType<any>;
}

export function buildIconsObject(foundIcons: RequireContext) {
    const iconObject: ComponentDictionary = {};
    for (const iconKey of foundIcons.keys()) {
        const name = iconKey.replace("./", "").replace(".tsx", "");
        const iconComponent = foundIcons(iconKey).default as React.ComponentType<any>;
        if (iconComponent) {
            iconObject[name] = iconComponent;
        }
    }
    return iconObject;
}

const icons = require.context("./", true, /\/(?!AllIcons).+\.tsx$/);
const iconsObject = buildIconsObject(icons);

export default iconsObject;
